import React from 'react';
import { snackbarBaseStyle } from './styles';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import { CloseButtonComponent } from '../../Utilities/utils/CloseButtonComponent';
import * as meta from '../../meta-data.json';

export const overrides = (props: any) => {
	const HTMLAttrs = getHTMLAttributes(props);
	return {
		Body: {
			style: ({ $theme }: any) => {
				return {
					...snackbarBaseStyle(props.kind, props.phantom, $theme, props.displayBlock),
					width: 'auto',
				};
			},
			props: {
				'data-epo': `epo-feedback-${meta.version}`,
				part: `epo-feedback-${meta.version}`,
				...HTMLAttrs.dataProps,
				...HTMLAttrs.ariaProps,
				...getBaseCustomProps(props),
				role: 'alert',
				id: props.id,
			},
		},
		CloseIcon: {
			component: (restProps: any) => <CloseButtonComponent {...restProps} />,
		},
		InnerContainer: {
			style: () => {
				return {
					overflow: 'hidden',
					color: 'var(--epods--color-text-primary)'
				};
			},
		},
	};
};
